
import { Component, Vue, Watch } from 'vue-property-decorator';

import OrderSearch from './components/OrderSearchCustom.vue';
import OrderList from './components/OrderList.vue';
import { ViewType, OrderServiceStage } from '@/types/orderServicer';

@Component({
  name: 'orderServicerUntreated',
  components: {
    OrderSearch,
    OrderList
  }
})
export default class extends Vue {
  private stage = OrderServiceStage.SERVICE_STAGE_UNDEAL;
  private vt = ViewType.ORDER_SERVICER_UNTREATED;
}
